import '/app/brewery-packages/layout/grid-old/src/grid.css-raw';
export default {
  "wideOffset5": "user-bag-page-by-city-91bba550-wideOffset5-WXUgJq",
  "defaultOffset11": "user-bag-page-by-city-91bba550-defaultOffset11-WXUgJq",
  "tinyOffset7": "user-bag-page-by-city-91bba550-tinyOffset7-WXUgJq",
  "wide3": "user-bag-page-by-city-91bba550-wide3-WXUgJq",
  "tinyOffset6": "user-bag-page-by-city-91bba550-tinyOffset6-WXUgJq",
  "xwide7": "user-bag-page-by-city-91bba550-xwide7-WXUgJq",
  "xwide9": "user-bag-page-by-city-91bba550-xwide9-WXUgJq",
  "default7": "user-bag-page-by-city-91bba550-default7-WXUgJq",
  "wideOffset0": "user-bag-page-by-city-91bba550-wideOffset0-WXUgJq",
  "confinedOffset0": "user-bag-page-by-city-91bba550-confinedOffset0-WXUgJq",
  "col": "user-bag-page-by-city-91bba550-col-WXUgJq",
  "xwide1": "user-bag-page-by-city-91bba550-xwide1-WXUgJq",
  "tinyOffset0": "user-bag-page-by-city-91bba550-tinyOffset0-WXUgJq",
  "default10": "user-bag-page-by-city-91bba550-default10-WXUgJq",
  "tiny4": "user-bag-page-by-city-91bba550-tiny4-WXUgJq",
  "xwideOffset9": "user-bag-page-by-city-91bba550-xwideOffset9-WXUgJq",
  "tinyOffset3": "user-bag-page-by-city-91bba550-tinyOffset3-WXUgJq",
  "xwideOffset10": "user-bag-page-by-city-91bba550-xwideOffset10-WXUgJq",
  "defaultOffset5": "user-bag-page-by-city-91bba550-defaultOffset5-WXUgJq",
  "confinedOffset1": "user-bag-page-by-city-91bba550-confinedOffset1-WXUgJq",
  "tinyOffset1": "user-bag-page-by-city-91bba550-tinyOffset1-WXUgJq",
  "confined11": "user-bag-page-by-city-91bba550-confined11-WXUgJq",
  "row": "user-bag-page-by-city-91bba550-row-WXUgJq",
  "confinedOffset2": "user-bag-page-by-city-91bba550-confinedOffset2-WXUgJq",
  "confined0": "user-bag-page-by-city-91bba550-confined0-WXUgJq",
  "tinyOffset4": "user-bag-page-by-city-91bba550-tinyOffset4-WXUgJq",
  "confined7": "user-bag-page-by-city-91bba550-confined7-WXUgJq",
  "wide12": "user-bag-page-by-city-91bba550-wide12-WXUgJq",
  "tiny10": "user-bag-page-by-city-91bba550-tiny10-WXUgJq",
  "gridContainer": "user-bag-page-by-city-91bba550-gridContainer-WXUgJq",
  "tinyOffset11": "user-bag-page-by-city-91bba550-tinyOffset11-WXUgJq",
  "defaultOffset3": "user-bag-page-by-city-91bba550-defaultOffset3-WXUgJq",
  "wide10": "user-bag-page-by-city-91bba550-wide10-WXUgJq",
  "default3": "user-bag-page-by-city-91bba550-default3-WXUgJq",
  "wide11": "user-bag-page-by-city-91bba550-wide11-WXUgJq",
  "xwideOffset0": "user-bag-page-by-city-91bba550-xwideOffset0-WXUgJq",
  "wide0": "user-bag-page-by-city-91bba550-wide0-WXUgJq",
  "xwide0": "user-bag-page-by-city-91bba550-xwide0-WXUgJq",
  "wideOffset4": "user-bag-page-by-city-91bba550-wideOffset4-WXUgJq",
  "xwideOffset11": "user-bag-page-by-city-91bba550-xwideOffset11-WXUgJq",
  "wide5": "user-bag-page-by-city-91bba550-wide5-WXUgJq",
  "wideOffset1": "user-bag-page-by-city-91bba550-wideOffset1-WXUgJq",
  "tinyOffset8": "user-bag-page-by-city-91bba550-tinyOffset8-WXUgJq",
  "grid": "user-bag-page-by-city-91bba550-grid-WXUgJq",
  "tiny12": "user-bag-page-by-city-91bba550-tiny12-WXUgJq",
  "tiny8": "user-bag-page-by-city-91bba550-tiny8-WXUgJq",
  "tiny11": "user-bag-page-by-city-91bba550-tiny11-WXUgJq",
  "tiny7": "user-bag-page-by-city-91bba550-tiny7-WXUgJq",
  "wideOffset11": "user-bag-page-by-city-91bba550-wideOffset11-WXUgJq",
  "defaultOffset4": "user-bag-page-by-city-91bba550-defaultOffset4-WXUgJq",
  "xwide8": "user-bag-page-by-city-91bba550-xwide8-WXUgJq",
  "confinedOffset3": "user-bag-page-by-city-91bba550-confinedOffset3-WXUgJq",
  "confined3": "user-bag-page-by-city-91bba550-confined3-WXUgJq",
  "wideGridContainer": "user-bag-page-by-city-91bba550-wideGridContainer-WXUgJq",
  "confined10": "user-bag-page-by-city-91bba550-confined10-WXUgJq",
  "default6": "user-bag-page-by-city-91bba550-default6-WXUgJq",
  "wide4": "user-bag-page-by-city-91bba550-wide4-WXUgJq",
  "confined5": "user-bag-page-by-city-91bba550-confined5-WXUgJq",
  "wideOffset6": "user-bag-page-by-city-91bba550-wideOffset6-WXUgJq",
  "tiny1": "user-bag-page-by-city-91bba550-tiny1-WXUgJq",
  "xwideOffset1": "user-bag-page-by-city-91bba550-xwideOffset1-WXUgJq",
  "wideOffset10": "user-bag-page-by-city-91bba550-wideOffset10-WXUgJq",
  "confined9": "user-bag-page-by-city-91bba550-confined9-WXUgJq",
  "tiny0": "user-bag-page-by-city-91bba550-tiny0-WXUgJq",
  "standardGridContainer": "user-bag-page-by-city-91bba550-standardGridContainer-WXUgJq",
  "tiny2": "user-bag-page-by-city-91bba550-tiny2-WXUgJq",
  "confinedOffset6": "user-bag-page-by-city-91bba550-confinedOffset6-WXUgJq",
  "wide9": "user-bag-page-by-city-91bba550-wide9-WXUgJq",
  "confined8": "user-bag-page-by-city-91bba550-confined8-WXUgJq",
  "confinedOffset11": "user-bag-page-by-city-91bba550-confinedOffset11-WXUgJq",
  "wideOffset9": "user-bag-page-by-city-91bba550-wideOffset9-WXUgJq",
  "confined2": "user-bag-page-by-city-91bba550-confined2-WXUgJq",
  "tinyOffset9": "user-bag-page-by-city-91bba550-tinyOffset9-WXUgJq",
  "tiny5": "user-bag-page-by-city-91bba550-tiny5-WXUgJq",
  "defaultOffset10": "user-bag-page-by-city-91bba550-defaultOffset10-WXUgJq",
  "wide8": "user-bag-page-by-city-91bba550-wide8-WXUgJq",
  "xwideOffset2": "user-bag-page-by-city-91bba550-xwideOffset2-WXUgJq",
  "xwide5": "user-bag-page-by-city-91bba550-xwide5-WXUgJq",
  "confinedOffset4": "user-bag-page-by-city-91bba550-confinedOffset4-WXUgJq",
  "confined4": "user-bag-page-by-city-91bba550-confined4-WXUgJq",
  "xwide12": "user-bag-page-by-city-91bba550-xwide12-WXUgJq",
  "tinyOffset5": "user-bag-page-by-city-91bba550-tinyOffset5-WXUgJq",
  "confinedOffset10": "user-bag-page-by-city-91bba550-confinedOffset10-WXUgJq",
  "defaultOffset8": "user-bag-page-by-city-91bba550-defaultOffset8-WXUgJq",
  "default8": "user-bag-page-by-city-91bba550-default8-WXUgJq",
  "xwideOffset7": "user-bag-page-by-city-91bba550-xwideOffset7-WXUgJq",
  "xwideOffset4": "user-bag-page-by-city-91bba550-xwideOffset4-WXUgJq",
  "xwide10": "user-bag-page-by-city-91bba550-xwide10-WXUgJq",
  "xwide6": "user-bag-page-by-city-91bba550-xwide6-WXUgJq",
  "defaultOffset7": "user-bag-page-by-city-91bba550-defaultOffset7-WXUgJq",
  "default5": "user-bag-page-by-city-91bba550-default5-WXUgJq",
  "wide2": "user-bag-page-by-city-91bba550-wide2-WXUgJq",
  "default2": "user-bag-page-by-city-91bba550-default2-WXUgJq",
  "confined6": "user-bag-page-by-city-91bba550-confined6-WXUgJq",
  "tinyOffset2": "user-bag-page-by-city-91bba550-tinyOffset2-WXUgJq",
  "confinedOffset8": "user-bag-page-by-city-91bba550-confinedOffset8-WXUgJq",
  "xwide4": "user-bag-page-by-city-91bba550-xwide4-WXUgJq",
  "tiny9": "user-bag-page-by-city-91bba550-tiny9-WXUgJq",
  "confinedOffset7": "user-bag-page-by-city-91bba550-confinedOffset7-WXUgJq",
  "wideOffset3": "user-bag-page-by-city-91bba550-wideOffset3-WXUgJq",
  "tiny3": "user-bag-page-by-city-91bba550-tiny3-WXUgJq",
  "xwideOffset3": "user-bag-page-by-city-91bba550-xwideOffset3-WXUgJq",
  "confinedOffset9": "user-bag-page-by-city-91bba550-confinedOffset9-WXUgJq",
  "armstrongGridContainer": "user-bag-page-by-city-91bba550-armstrongGridContainer-WXUgJq",
  "defaultOffset9": "user-bag-page-by-city-91bba550-defaultOffset9-WXUgJq",
  "xwide11": "user-bag-page-by-city-91bba550-xwide11-WXUgJq",
  "wide1": "user-bag-page-by-city-91bba550-wide1-WXUgJq",
  "default4": "user-bag-page-by-city-91bba550-default4-WXUgJq",
  "wideOffset7": "user-bag-page-by-city-91bba550-wideOffset7-WXUgJq",
  "tinyOffset10": "user-bag-page-by-city-91bba550-tinyOffset10-WXUgJq",
  "confined1": "user-bag-page-by-city-91bba550-confined1-WXUgJq",
  "default12": "user-bag-page-by-city-91bba550-default12-WXUgJq",
  "tiny6": "user-bag-page-by-city-91bba550-tiny6-WXUgJq",
  "default11": "user-bag-page-by-city-91bba550-default11-WXUgJq",
  "wide7": "user-bag-page-by-city-91bba550-wide7-WXUgJq",
  "xwideOffset5": "user-bag-page-by-city-91bba550-xwideOffset5-WXUgJq",
  "confinedOffset5": "user-bag-page-by-city-91bba550-confinedOffset5-WXUgJq",
  "default1": "user-bag-page-by-city-91bba550-default1-WXUgJq",
  "xwide2": "user-bag-page-by-city-91bba550-xwide2-WXUgJq",
  "defaultOffset1": "user-bag-page-by-city-91bba550-defaultOffset1-WXUgJq",
  "defaultOffset2": "user-bag-page-by-city-91bba550-defaultOffset2-WXUgJq",
  "wideOffset2": "user-bag-page-by-city-91bba550-wideOffset2-WXUgJq",
  "wide6": "user-bag-page-by-city-91bba550-wide6-WXUgJq",
  "xwide3": "user-bag-page-by-city-91bba550-xwide3-WXUgJq",
  "confined12": "user-bag-page-by-city-91bba550-confined12-WXUgJq",
  "wideOffset8": "user-bag-page-by-city-91bba550-wideOffset8-WXUgJq",
  "defaultOffset6": "user-bag-page-by-city-91bba550-defaultOffset6-WXUgJq",
  "default0": "user-bag-page-by-city-91bba550-default0-WXUgJq",
  "default9": "user-bag-page-by-city-91bba550-default9-WXUgJq",
  "xwideOffset8": "user-bag-page-by-city-91bba550-xwideOffset8-WXUgJq",
  "xwideOffset6": "user-bag-page-by-city-91bba550-xwideOffset6-WXUgJq"
};